import { Box, styled } from "@mui/material"
import { IconContainerProps } from "./props"
import { getHeightAndWidth } from "./utils/getHeightAndWidth"

export const IconContainer = styled(Box, {
  shouldForwardProp: (props) =>
    props !== "bgColor" && props !== "containerSize",
})(({ bgColor, containerSize }: IconContainerProps) => ({
  background: bgColor,
  borderRadius: "40%",
  width: getHeightAndWidth(containerSize),
  height: getHeightAndWidth(containerSize),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}))
